import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        this.setState({ info });
        console.error('[ErrorBoundary]', error, info);
    }

    render() {
        if (this.state.error) {
            const { error, info } = this.state;
            return (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    background: '#1a0000', color: '#ff6b6b',
                    padding: '20px', overflowY: 'auto', zIndex: 99999,
                    fontFamily: 'monospace', fontSize: '13px'
                }}>
                    <div style={{ background: '#ff0000', color: '#fff', padding: '8px 12px', borderRadius: '6px', marginBottom: '12px', fontSize: '15px', fontWeight: 'bold' }}>
                        ERROR DE RENDERIZADO
                    </div>
                    <div style={{ background: '#2a0000', padding: '12px', borderRadius: '6px', marginBottom: '12px', wordBreak: 'break-all' }}>
                        <strong>Mensaje:</strong><br />
                        {error?.message || String(error)}
                    </div>
                    <div style={{ background: '#1a1a00', padding: '12px', borderRadius: '6px', marginBottom: '12px', wordBreak: 'break-all', whiteSpace: 'pre-wrap', fontSize: '11px', color: '#ffd700' }}>
                        <strong>Stack:</strong><br />
                        {error?.stack}
                    </div>
                    {info?.componentStack && (
                        <div style={{ background: '#001a1a', padding: '12px', borderRadius: '6px', wordBreak: 'break-all', whiteSpace: 'pre-wrap', fontSize: '11px', color: '#88ccff' }}>
                            <strong>Componente:</strong>
                            {info.componentStack}
                        </div>
                    )}
                    <button
                        onClick={() => this.setState({ error: null, info: null })}
                        style={{ marginTop: '16px', padding: '10px 20px', background: '#004488', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}
                    >
                        Reintentar
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
